export default __webpack_public_path__ + "static/reauxi-3dc833928d331f6890be41cf61200340.png";